/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { NewCampaignPageService } from '../../../services';

const MODULE_NAME = 'trag.machines.states.createCampaign';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.NewCampaignPageService'
  ) as NewCampaignPageService;
};

export const createCampaign = async (context: any, event: any) => {
  const currentState = 'GET_PAGE_CONTENT';
  const method = 'createCampaign';

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      const content = await srv.createCampaign(event?.pyaload);

      if (content) {
        return resolve({
          key: 'CREATE_CAMPAIGN_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Failed to create campaign';
        return reject({
          key: 'CREATE_CAMPAIGN_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'CREATE_CAMPAIGN_ERROR',
        value: _msg,
      });
    }
  });
};
